import { styled } from 'styled-components';

import { VersionedRouterLink } from 'components/VersionedLink/VersionedRouterLink';
import { linkStyles } from 'theme/theme';

export const StyledVersionedRouterLink = styled(VersionedRouterLink)`
  ${linkStyles}
`;
